import global from '@/assets/js/global'
import axios from 'axios'

const path = 'firestoreSchool'
const pathGroup = 'firestoreSchool/groupConfig'

/*
 *  CONFIG
 */

const get = async (token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.get(`${global.server}${path}`, options)

  return res.data
}

const put = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.put(`${global.server}${path}`, body, options)
  return res.data
}

/*
 *  CONFIG-GROUP
 */

const getGroup = async (token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.get(`${global.server}${pathGroup}`, options)

  return res.data
}

const putGroup = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.put(`${global.server}${pathGroup}`, body, options)
  return res.data
}

const group = {
  get: getGroup,
  put: putGroup,
}

export default {
  get,
  put,
  group,
}
